type IconProps = {
  style?: React.CSSProperties;
};

export const ScreenshotIcon = ({ style = {} }: IconProps) => {
  return (
    <img
      src="/assets/icons/screenshot-icon.svg"
      alt="Screenshot"
      style={{ height: '1.6rem', ...style }}
    />
  );
};
